import { memo } from 'react';

import { LineType } from '../../common/types';

import { LineLink } from './line-link';

type OwnProps = {
  isActivePermalink: boolean;
  activePermalinkStyle: string;
  lineNumbers: LineNumberDetails[];
  permalink: string;
  onPermalinkClick?: (permalink: string) => void;
  showPermalinks: boolean;
  highlightDivider?: boolean;
};

export type LineNumberDetails = {
  number?: number;
  label?: string;
  type?: LineType;
};

export const LineNumbers = memo(
  ({
    isActivePermalink,
    activePermalinkStyle,
    lineNumbers,
    showPermalinks,
    onPermalinkClick,
    permalink,
    highlightDivider,
  }: OwnProps) => {
    const oldAndNewLines = lineNumbers.length === 2;
    const isRemoved =
      (oldAndNewLines && lineNumbers[0]?.number && !lineNumbers[1]?.number) ||
      lineNumbers[0]?.type === 'del';
    const isAdded =
      (oldAndNewLines && !lineNumbers[0]?.number && lineNumbers[1]?.number) ||
      lineNumbers[0]?.type === 'add';
    const isContext =
      oldAndNewLines && lineNumbers[0]?.number && lineNumbers[1]?.number;

    return (
      <div
        className={[
          'line-numbers',
          'gutter-width-apply-width',
          isActivePermalink ? activePermalinkStyle : '',
          isAdded ? 'added-color' : '',
          isRemoved ? 'removed-color' : '',
          isContext ? 'context-color' : '',
          highlightDivider ? 'highlight-divider' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        data-key="code-line-number"
        data-line-number={!oldAndNewLines ? lineNumbers[0]?.number : undefined}
        data-old-line-number={
          oldAndNewLines ? lineNumbers[0]?.number : undefined
        }
        data-new-line-number={
          oldAndNewLines ? lineNumbers[1]?.number : undefined
        }
      >
        {lineNumbers.map(({ number, label }, i) =>
          showPermalinks ? (
            <LineLink
              key={`line-number-${number}-${i}`}
              number={number}
              label={label}
              permalink={permalink}
              onPermalinkClick={onPermalinkClick}
            />
          ) : (
            <div
              className="line-number"
              key={`line-number-${number}-${i}`}
              aria-hidden={!number}
              aria-label={label}
            >
              <span aria-hidden="true">{number}</span>
            </div>
          )
        )}
      </div>
    );
  }
);
